<template>
  <v-card>
    <v-card-title class="d-flex align-center">
      <h1 class="text-2xl font-weight-semibold">
        {{ title }}
      </h1>
    </v-card-title>
    <v-card-text>
      <validation-observer ref="formCustomer">
        <v-form class="multi-col-validation mt-6">
          <v-row>
            <v-col
              md="6"
              cols="12"
            >
              <validation-provider
                v-slot="{ errors, valid }"
                name="name"
                rules="required"
              >
                <v-text-field
                  v-model="customer.name"
                  outlined
                  dense
                  label="Nome"
                  autocomplete="new-password"
                  :hide-details="valid"
                  :error-messages="errors"
                  :success="valid"
                  required
                />
              </validation-provider>
            </v-col>

            <v-col
              md="6"
              cols="12"
            >
              <validation-provider
                v-slot="{ errors, valid }"
                name="email"
                rules="required|email"
              >
                <v-text-field
                  v-model="customer.email"
                  outlined
                  dense
                  label="Email"
                  autocomplete="new-password"
                  :hide-details="valid"
                  :error-messages="errors"
                  :success="valid"
                  required
                />
              </validation-provider>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors, valid }"
                name="password"
                :rules="{ required: !isEdit }"
              >
                <v-text-field
                  v-model="customer.password"
                  outlined
                  dense
                  label="Senha"
                  autocomplete="new-password"
                  :hide-details="valid"
                  :type="isPasswordVisible ? 'text' : 'password'"
                  :append-icon="
                    isPasswordVisible
                      ? icons.mdiEyeOffOutline
                      : icons.mdiEyeOutline
                  "
                  :error-messages="errors"
                  :success="valid"
                  required
                  @click:append="isPasswordVisible = !isPasswordVisible"
                />
              </validation-provider>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors, valid }"
                name="passwordConfirmation"
                :rules="{ required: !isEdit, confirmed: 'password' }"
              >
                <v-text-field
                  v-model="customer.passwordConfirmation"
                  outlined
                  dense
                  label="Confirmar senha"
                  autocomplete="new-password"
                  :hide-details="valid"
                  :type="isConfirmPasswordVisible ? 'text' : 'password'"
                  :append-icon="
                    isConfirmPasswordVisible
                      ? icons.mdiEyeOffOutline
                      : icons.mdiEyeOutline
                  "
                  :error-messages="errors"
                  :success="valid"
                  required
                  @click:append="
                    isConfirmPasswordVisible = !isConfirmPasswordVisible
                  "
                />
              </validation-provider>
            </v-col>

            <v-col cols="12">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                @click="save"
              >
                {{ $t("button.save") }}
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                class="mt-4"
                @click="goToCustomers"
              >
                {{ $t("button.cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </validation-observer>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js';
// import laravelApi from '../../apis/api_laravel';

export default {
  data() {
    return {
      title: '',
      customer: {},
      isPasswordVisible: false,
      isConfirmPasswordVisible: false,
      isEdit: false,
      icons: {
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
    };
  },
  async mounted() {
    if (this.$route.params.id) {
      this.title = this.$t('form.editCustomer');
      this.isEdit = true;
      try {
        this.customer = await this.$api.customer.getCustomer(
          this.$route.params.id,
        );
      } catch (error) {
        this.$store.dispatch('NOTIFICATION_ERROR', error.message);
      }
    } else {
      this.title = this.$t('form.newCustomer');
      this.isEdit = false;
    }
  },
  methods: {
    async save() {
      if (await this.$refs.formCustomer.validate()) {
        const formData = new FormData();
        formData.append('name', this.customer.name);
        formData.append('email', this.customer.email);
        formData.append('occupation', 'Médico');
        formData.append('password', this.customer.password);
        formData.append('manager', false);
        try {
          if (this.customer.id) {
            await this.$api.customer.putCustomer(this.customer);
            // laravelApi.put(`/users/${this.customer.id}`, formData);
          } else {
            // laravelApi.post('/users', formData);
            await this.$api.customer.postCustomer(this.customer);
          }
          this.goToCustomers();
        } catch (error) {
          this.$store.dispatch('NOTIFICATION_ERROR', error.message);
        }
      }
    },
    goToCustomers() {
      this.$router.push('/customers');
    },
  },
};
</script>
